document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.gallery-carousel[data-section-type="gallery-carousel"]');

  sections.forEach(section => {
    if (!section) return;

    setTimeout(() => {
      const swiper = section.querySelector('.swiper')?.swiper;
      if (!swiper) return;

      swiper.params.loop = true;
      swiper.loopCreate();

      swiper.params.speed = 1000;
      swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.22, 1, 0.36, 1)';

      swiper.update();
    }, 200);
  });
});
